import { createActionContext } from '@/workflow-builder/_pure/model/context';
import { createActionError } from '@/workflow-builder/_pure/model/error';
import { generateIdentifier } from '@toolproof-core/lib/identifier-generation';
import { reduceAction } from '@/workflow-builder/_pure/model/reducer';
import type { Config } from '@/workflow/_contract/config';
import type { CosmosDataModel } from '@/workflow/_contract/cosmosData';
import type { Action } from '@/workflow-builder/_contract/command';
import type { RuntimeState } from '@/workflow-builder/_contract/runtime';

export function dispatchAction(args: {
    config: Config;
    runtimeState: RuntimeState;
    cosmosData: CosmosDataModel;
    action: Action;
}): RuntimeState {
    const runtimeState: RuntimeState = {
        ...args.runtimeState,
        toolMap: args.cosmosData.toolMap,
    };

    const context = createActionContext({
        config: args.config,
        cosmosData: args.cosmosData,
        runtimeState,
    });

    if (args.action.command === 'create_tool_step' && !context.selectableToolHandleSet.has(args.action.toolHandle)) {
        return {
            ...runtimeState,
            error: createActionError(
                args.action.command,
                `Tool '${args.action.toolHandle}' is not selectable in the current Tool Set.`,
            ),
        };
    }

    return reduceAction(runtimeState, args.action, generateIdentifier);
}
